import { FileMimetype } from 'constants/misc'

/**
 * Converts a data URL to a File object
 * @param dataUrl - The data URL string (e.g., "data:image/jpeg;base64,...")
 * @param filename - The filename for the resulting File object
 * @returns File object created from the data URL
 * @throws Error if the data URL is invalid
 */
export function dataURLToFile(dataUrl: string, filename: string): File {
  const [meta, content] = dataUrl.split(',')
  if (!meta || !content) {
    throw new Error('invalid_data_url')
  }
  const mimeMatch = meta.match(/:(.*?);/)
  const mime = mimeMatch ? mimeMatch[1] : FileMimetype.IMAGE_JPEG
  const binaryString = atob(content)
  const len = binaryString.length
  const u8arr = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    u8arr[i] = binaryString.charCodeAt(i)
  }
  return new File([u8arr], filename, { type: mime })
}
